import { createAsyncThunk } from "@reduxjs/toolkit";
import userService from "../../../api/services/user";

export const fetchUserInfo = createAsyncThunk(
  "user/fetch-user-info",
  async () => {
    return await userService.fetchUserInfo();
  },
);

export const addDailyCredits = createAsyncThunk(
  "user/add-daily-credits",
  async () => {
    return await userService.addDailyCredits();
  },
);

export const spinTheWheel = createAsyncThunk("user/spin-wheel", async () => {
  return await userService.spinTheWheel();
});

export const changeUsername = createAsyncThunk(
  "user/set-username",
  async (requestData) => {
    return await userService.setUsername(requestData);
  },
);

export const deleteAccount = createAsyncThunk(
  "user/delete-account",
  async (requestData) => {
    return await userService.deleteAccount(requestData);
  },
);

export const getReferralUsers = createAsyncThunk(
  "user/referral-users",
  async () => {
    return await userService.getReferralUsers();
  },
);

export const getSameAuthorCollections = createAsyncThunk(
  "user/get-same-author-collections",
  async (userId) => {
    return await userService.getSameAuthorCollections(userId);
  },
);

export const submitRequest = createAsyncThunk(
  "user/submit-request",
  async (requestData) => {
    return await userService.submitRequest(requestData);
  },
);
